import { ReactNode, useState, useEffect } from "react";
import Modal from "../modal/Modal";
import { MODAL_TYPE } from "../../constants";
import Button from "../buttons/button/Button";
import { BUTTON_TYPES } from "../buttons/button/ButtonTypes";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import styles from "./AsosWorldModal.scss";

interface AsosWorldModalProps {
  open: boolean;
  closeModal: () => void;
  modalId: string;
  title: ReactNode;
  subtitle?: ReactNode;
  copy: ReactNode;
  consentLabel?: ReactNode;
  buttonText: string;
  onButtonClick: (args: { consented: boolean }) => void;
}

const AsosWorldModal = ({
  open,
  closeModal,
  modalId,
  title,
  subtitle,
  copy,
  consentLabel,
  buttonText,
  onButtonClick,
}: AsosWorldModalProps) => {
  const { getTranslation } = useRuntimeConstants() as {
    getTranslation: (key: string, values?: Record<string, string>) => string;
  };
  const [consented, setConsented] = useState(false);

  useEffect(() => {
    if (!open) {
      setConsented(false);
    }
  }, [open]);

  const termsLink = getTranslation("loyalty_terms_privacy_hyperlink_copy", {
    termslink: `<a href="/terms-and-conditions" target="_blank" rel="noopener noreferrer">${getTranslation(
      "loyalty_terms_link",
    )}</a>`,
    privacypolicylink: `<a href="/privacy-policy" target="_blank" rel="noopener noreferrer">${getTranslation(
      "loyalty_privacy_link",
    )}</a>`,
  });

  return (
    <Modal
      open={open}
      closeModal={closeModal}
      modalType={MODAL_TYPE.CENTER}
      contentLoaded
      modalId={modalId}
      withScrollBar={false}
    >
      <div className={styles.notifyMeModal}>
        <div className={styles.icon}>
          <div className="product-asos-world" />
        </div>
        <div className={styles.header}>{title}</div>
        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        <div className={styles.copy}>{copy}</div>
        <div className={styles.consentContainer}>
          {consentLabel && (
            <label className={styles.consent}>
              <input
                type="checkbox"
                checked={consented}
                onChange={(e) => setConsented(e.target.checked)}
                className={styles.consentCheckbox}
              />
              <span className={styles.consentLabel}>{consentLabel}</span>
            </label>
          )}
        </div>
        <Button
          type={BUTTON_TYPES.loyaltyFullWidth}
          handleClick={() => onButtonClick({ consented })}
        >
          {buttonText}
        </Button>
        <Button
          type={BUTTON_TYPES.loyaltySecondaryFullWidth}
          handleClick={closeModal}
        >
          {getTranslation("pdp_eap_modal_decline")}
        </Button>
        <div
          className={styles.termsLinkText}
          dangerouslySetInnerHTML={{ __html: termsLink }}
        />
      </div>
    </Modal>
  );
};

export default AsosWorldModal;
